import countryList from 'react-select-country-list';

export const getCountryName = (symbol: string): string => countryList().getLabel(symbol);

export const getCountryCode = (label: string): string => countryList().getValue(label);
